import { render, staticRenderFns } from "./UploadModelDialog.vue?vue&type=template&id=b12f30ee"
import script from "./UploadModelDialog.vue?vue&type=script&lang=js"
export * from "./UploadModelDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadModelDialog.vue?vue&type=style&index=0&id=b12f30ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports